// extracted by mini-css-extract-plugin
module.exports = {"list__item":"ListItem_list__item__1RBBE","terms":"ListItem_terms__1rcyV","list__item_after":"ListItem_list__item_after__2B7Pz","list__item_text":"ListItem_list__item_text__3oN_l"};